import { Assignment } from '../../types/interfaces';

type AssignmentLike = Assignment & {
  exercise?: Assignment['exercise'] & {
    exerciseLearningMaterials?: Array<{
      material?: {
        title?: string;
      };
      showToStudent?: boolean;
    }>;
    lesson?: {
      title?: string;
      course?: {
        name?: string;
      };
    };
  };
};

export const getAssignmentTopic = (assignment: AssignmentLike | null | undefined): string => {
  if (!assignment) {
    return 'Nykyinen tehtävä';
  }

  const courseName = assignment.exercise?.lesson?.course?.name?.trim();
  const lessonTitle = assignment.exercise?.lesson?.title?.trim();
  const materialTitle = assignment.exercise?.exerciseLearningMaterials?.[0]?.material?.title?.trim();

  return [courseName, lessonTitle, materialTitle].filter(Boolean).join(' / ') || 'Nykyinen tehtävä';
};

export const getAssignmentReminder = (assignment: AssignmentLike | null | undefined): string => {
  if (!assignment) {
    return 'Tehtävä odottaa sopivaa seuraavaa askelta.';
  }

  const topic = getAssignmentTopic(assignment);
  const dueDate = assignment.dueDate ? new Date(assignment.dueDate).toLocaleDateString('fi-FI') : null;

  if (dueDate) {
    return `Aihe: ${topic}. Eräpäivä: ${dueDate}. Status: ${assignment.status}.`;
  }

  return `Aihe: ${topic}. Status: ${assignment.status}.`;
};

export const getDefaultTutorGreeting = (
  studentName: string | undefined,
  assignment: AssignmentLike | null | undefined,
): string => {
  const firstName = studentName?.split(' ')[0] || 'kamu';
  const topic = getAssignmentTopic(assignment);
  const dueDate = assignment?.dueDate ? new Date(assignment.dueDate).toLocaleDateString('fi-FI') : null;

  return [
    `Moi ${firstName}, minä olen Tsemppi. Olen sellainen tehtäväkaveri, joka ei spoilaile vastauksia mutta auttaa sinut maaliin ilman turhaa draamaa.`,
    dueDate
      ? `Tämä tehtävä liittyy aiheeseen ${topic} ja eräpäivä on ${dueDate}.`
      : `Tämä tehtävä liittyy aiheeseen ${topic}.`,
    'Miten koulupäivä meni, asteikolla ihan jees -> oliko tämä joku boss level? Voit myös painaa noista kolmesta pikavaihtoehdosta.',
  ].join(' ');
};

export const getVisibleMaterialFlag = (assignment: AssignmentLike | null | undefined): boolean => {
  return Boolean(assignment?.exercise?.exerciseLearningMaterials?.[0]?.showToStudent);
};

export const getAssignmentInstructionLabel = (assignment: AssignmentLike | null | undefined): string => {
  return assignment?.exercise?.instructions?.trim() || 'Tehtävä';
};

export const getAssignmentTopics = (assignments: AssignmentLike[]): string[] => {
  const uniqueTopics = new Set<string>();

  assignments.forEach((assignment) => {
    const topic = getAssignmentTopic(assignment);
    if (topic) {
      uniqueTopics.add(topic);
    }
  });

  return Array.from(uniqueTopics).slice(0, 5);
};